import { jsx as c } from "react/jsx-runtime";
import { BREAKPOINTS as f } from "../../constants/breakpoints.js";
import { getImageProps as u } from "next/image";
import { useMemo as i } from "react";
const g = (t) => {
  if (!t || typeof t == "string")
    return t;
  const o = (r) => typeof r == "number" ? `${Math.floor(100 / (12 / r))}vw` : r;
  return Object.entries(t).map(([r, e]) => [f[r], e]).sort(([r], [e]) => e - r).map(([r, e]) => {
    const n = o(e);
    return r ? `(min-width: ${r}px) ${n}` : n;
  }).join(", ");
}, S = (t) => typeof t == "string" && t.startsWith("data:"), P = ({ media: t, src: o, width: r, height: e, fill: n, quality: p, sizes: a }) => {
  const m = i(() => g(a), [a]), s = i(() => S(o) ? {
    srcSet: o,
    width: r,
    height: e,
    sizes: m
  } : u({
    src: o,
    width: r,
    height: e,
    fill: n,
    quality: p,
    sizes: m,
    // Pass in an empty alt since <source> element's don't accept alt.
    alt: ""
  }).props, [n, e, p, m, o, r]);
  return /* @__PURE__ */ c(
    "source",
    {
      media: t,
      srcSet: s.srcSet,
      width: s.width,
      height: s.height,
      sizes: s.sizes
    }
  );
};
export {
  P as ImageSource,
  g as getImageSizes,
  S as isDataUrl
};
